import React from "react";
import { Breadcrumbs, Stack } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import ConfirmationController from "../ConfirmationController/index.js";
import { CheckinHeader } from "./CheckinHeader.js";
import { CheckinHowTo } from "./CheckinHowTo.js";
import { CheckinSegmentHeader } from "./CheckinSegmentHeader.js";
import Wrapper from "../../atoms/Wrapper/index.js";
import { CheckInInfoCard } from "./CheckinInfoCard.js";
export const WebCheckinInner = ({ order, segment, filteredLegsWithOpenedCheckIn }) => {
    const i18n = useI18n();
    const { createUrl } = useCreateUrl();
    return (React.createElement(ConfirmationController, null, () => (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, null,
            React.createElement(Stack, { gap: 4 },
                React.createElement(Breadcrumbs, { back: true, items: [
                        {
                            text: i18n.trans(t("flights_pb_checkin_navigation")),
                            href: createUrl(`/booking/order-details/${order?.orderToken}`)
                        }
                    ] }),
                React.createElement(CheckinHeader, { segment: segment }),
                React.createElement("div", null))),
        React.createElement(Wrapper, null,
            React.createElement(CheckinHowTo, { order: order })),
        React.createElement(Wrapper, null,
            React.createElement(Stack, { gap: 4 },
                React.createElement(CheckinSegmentHeader, { segment: segment, showSubHeader: filteredLegsWithOpenedCheckIn.length === 1, showMultiPnrAlert: filteredLegsWithOpenedCheckIn.length > 1 }),
                filteredLegsWithOpenedCheckIn.map(({ leg, checkinInfoForLeg }) => {
                    const { legIdentifier: { segmentIndex, legIndex }, isOnlineCheckinOpen } = checkinInfoForLeg;
                    return (React.createElement(CheckInInfoCard, { key: legIndex, leg: leg, segmentIndex: segmentIndex, legIndex: legIndex, openCheckin: isOnlineCheckinOpen, checkInInfo: checkinInfoForLeg, showHeader: filteredLegsWithOpenedCheckIn.length > 1, showVuelingAlert: true }));
                })))))));
};
